var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v("Your card has been succesfully sent!"),_c('br'),_c('br'),_vm._v("To send another card, please close this window and follow your company's process to start a new order.")])])
}]

export { render, staticRenderFns }